import type {ReactElement} from 'react';
import {useContext} from 'react';
import {Icon} from '@Components/icon-v2/icon';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {formMakerContext} from '@FormMakerReact/form-maker.context';
import {EditorViewport} from '@FormMakerReact/form-maker.types';
import {navigateBackFromSignupFormEditor} from '@FormMakerReact/lib/form-maker-access-library';

export function BackButton(): ReactElement | null {
  const {state, store} = useContext(formMakerContext);
  if (state.editorViewport === EditorViewport.MOBILE) {
    return null;
  }
  return (
    <Icon
      icon="icon-arrow-left"
      shape={IconShape.SQUARE}
      type={IconType.DARK_GHOST}
      size={IconSize.SIZE_ICON_20}
      ariaLabel={window.i18next.t('pmwjs_form_maker_back_to_dashboard')}
      onClick={(): void => {
        navigateBackFromSignupFormEditor(store);
      }}
    />
  );
}
